import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import EmbedMain from '../components';

const mapStateToProps = () => ({
});

function mapDispatchToProps() {
  return {
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EmbedMain));



// WEBPACK FOOTER //
// ./src/routes/Embed/Main/container/index.js